module.exports = __webpack_public_path__ + "img/bt.1041eeda.svg";